import axios from "axios";
import { store } from "./store.js";
import { get } from "lodash-es";

const httpClient = axios.create();
const defaultErrorMessage =
    "HealtheConnections Data Contributors is currently unavailable.";

/**
 * Default error handling for HTTP requests
 * @param {Object} error
 */
const handleError = function(error) {
    console.error(error);

    // If 401, clear auth store and trigger message
    if (get(error, "response.status") === 401) {
        store.clearAuthUser();
        store.clearAuthOrg();

        store.setMask();
    } else {
        store.setToast({ message: defaultErrorMessage });
    }
};

export { httpClient, handleError };
